import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import formValues from '../../shared/form_values';

class Form extends Component {
  onSubmit = (event) => {
    event.preventDefault();
    const values = formValues(event.target.elements);
    this.props.handleLogin(values);
  };

  render() {
    return (
      <form id="login-form" onSubmit={(e) => { this.onSubmit(e); }}>
        <div className="login-input-element">
          <TextField
            required
            id="login_id"
            label={<FormattedMessage id="login.account_label" />}
            defaultValue=""
            className="login-input-text-field"
            margin="normal"
            variant="outlined"
          />
        </div>
        <div className="login-input-element">
          <TextField
            id="password"
            label={<FormattedMessage id="login.password_label" />}
            type="password"
            autoComplete="current-password"
            className="login-input-text-field"
            margin="normal"
            variant="outlined"
          />
        </div>
        <div className="login-input-element">
          <Button type="submit" size="large" variant="contained" color="primary" className="login-button-block" >
            <FormattedMessage id="login.login_button" />
          </Button>
        </div>
      </form>
    );
  }
}

Form.propTypes = {
  handleLogin: PropTypes.func.isRequired,
  // t: PropTypes.func.isRequired,
};

export default Form;
// export default withTranslation()(Form);
